import 'bootstrap/dist/css/bootstrap.css';
import 'leaflet/dist/leaflet.css';
import './content/css/app.css';
import 'angularjs-color-picker/dist/angularjs-color-picker.min.css';
import 'angularjs-color-picker/dist/themes/angularjs-color-picker-bootstrap.min.css';

import angular from 'angular';
import ngRoute from 'angular-route';

require('angular-ui-bootstrap/dist/ui-bootstrap-tpls.js');
require('leaflet');
require('angular-leaflet-directive/dist/angular-leaflet-directive.js');
require('tinycolor2/dist/tinycolor-min.js');
require('angularjs-color-picker/dist/angularjs-color-picker.min.js');

require('angular-animate/angular-animate.js');
require('angular-touch/angular-touch.js');
require('angular-touch/angular-touch.js');

require('ngStorage');
require('lodash');

(function () {
    'use strict';

    angular.module('app', [
        // 3rd pary components, see package.json
        'leaflet-directive',
        'ui.bootstrap',
        'ngStorage',
        'ngRoute',
        'color.picker'
    ]).config(["$locationProvider", function($locationProvider) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
    }]).run(["$rootScope", "$location", function ($rootScope, $location) {
        $rootScope.$on("$routeChangeStart", function (evt, to, from) {
            // requires authorization?
            if (to.authorize === true) {
                to.resolve = to.resolve || {};
                if (!to.resolve.authorizationResolver) {
                    // inject resolver
                    to.resolve.authorizationResolver = ["authService", function (authService) {
                        return authService.authorize();
                    }];
                }
            }
        });

        $rootScope.$on("$routeChangeError", function (evt, to, from, error) {
            if (error instanceof softship.helpers.AuthorizationError)
            {
                // redirect to login with original path we'll be returning back to
                $location
                    .path("/login")
                    .search("returnTo", to.originalPath);
            }
        });
    }]);
})();

// export default app;


// WEBPACK FOOTER //
// ./src/app.js